import { render, staticRenderFns } from "./courseCreaterPayPane.vue?vue&type=template&id=4147065b&scoped=true"
import script from "./courseCreaterPayPane.vue?vue&type=script&lang=js"
export * from "./courseCreaterPayPane.vue?vue&type=script&lang=js"
import style0 from "./courseCreaterPayPane.vue?vue&type=style&index=0&id=4147065b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4147065b",
  null
  
)

export default component.exports